import React, { Component, createRef, useState, useEffect, useRef } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import moment from "moment";
import dayjs from "dayjs";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Card, Row, Col, Input, DatePicker, Button, Table, Tabs, Modal, Badge, Tag, Tooltip } from "antd";
import { renderToString } from "react-dom/server";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
// import ReactTooltip from "react-tooltip";

function ExportInvoices(props) {
  const [clientDateRange, setClientDateRange] = useState([dayjs().subtract(90, "days"), dayjs()]);
  const [itemDateRange, setItemDateRange] = useState([dayjs().subtract(90, "days"), dayjs()]);
  const [invoiceDateRange, setInvoiceDateRange] = useState([dayjs().subtract(90, "days"), dayjs()]);
  const [clientFilter, setClientFilter] = useState({ value: false, label: "Unexported Clients" });
  const [invoiceFilter, setInvoiceFilter] = useState({ value: "false", label: "Unexported Invoices" });
  const [clients, setClients] = useState([]);
  const [payments, setPayments] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [clientsRowSelection, setClientsRowSelection] = useState({
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedClients(selectedRowKeys);
    },
  });
  const [paymentsRowSelection, setPaymentsRowSelection] = useState({
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedPayments(selectedRowKeys);
    },
  });
  const [invoicesRowSelection, setInvoicesRowSelection] = useState({
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedInvoices(selectedRowKeys);
    },
  });
  const [qbExportError, setQBExportError] = useState(null);

  const GetClients = async () => {
    let response = await props.AxiosRequest("/api/clients/get/exports", { exported: clientFilter?.value, created_at: clientDateRange });
    setClients(
      response.data.clients.map((m) => {
        return { ...m, key: m.id };
      }),
    );
    setSelectedClients([]);
  };
  const GetPayments = async () => {
    let response = await props.AxiosRequest("/api/payments/get/exports", { created_at: itemDateRange });
    setPayments(
      response.data.payments.map((m) => {
        return { ...m, key: m.id };
      }),
    );
    setSelectedPayments([]);
  };
  const GetInvoices = async () => {
    let response = await props.AxiosRequest("/api/invoices/get/exports", { exported: invoiceFilter?.value, created_at: invoiceDateRange });
    setInvoices(
      response.data.invoices.map((m) => {
        return { ...m, key: m.id };
      }),
    );
    setSelectedInvoices([]);
  };
  const GetExportFile = async () => {
    if (selectedClients.length === 0 && selectedInvoices.length === 0 && selectedPayments.length === 0) return props.MakeNotification("warning", "Please choose some items to export.");
    let response = await props.AxiosRequest("/api/exports/all", {
      invoices: selectedInvoices,
      clients: selectedClients,
      payments: selectedPayments,
    });
    if (response.data.status === "error") return props.MakeNotification("error", response.data.message || "There was a backend error. Please try again.");
    if (response.data.qberror) return setQBExportError(response.data.data);
    if (response.data.status === "success") {
      //HERE
      let iifContent = "data:text/iif;charset=utf-8,";
      iifContent += response.data.data.replace(/[?@=+$*#]/g, " ");
      let encodedURI = window.encodeURI(iifContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedURI);
      let now = dayjs().format("MMDDYY");
      link.setAttribute("download", "InvoiceExport-" + now + ".iif");
      document.body.appendChild(link); // Required for FF
      props.MakeNotification("success", "Export file successfully created.");
      link.click(); // This will download the data file
      GetClients();
      GetInvoices();
      GetPayments();
    }
  };

  const clients_columns = [
    {
      title: "Client Name",
      dataIndex: "name",
      key: "name",
      render: (value, row) => <Link to={"/client-details/" + row.tag}>{value}</Link>,
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "Date Created",
      dataIndex: "created_at",
      key: "created_at",
      render: (value, row) => (value ? props.MakeDateTimeReadable(value) : "Not Yet Exported"),
      sorter: (a, b) => (a.created_at > b.created_at ? 1 : -1),
    },
    {
      title: "Last Exported At",
      dataIndex: "exported_at",
      key: "exported_at",
      render: (value, row) => (value ? props.MakeDateTimeReadable(value) : "Not Yet Exported"),
      sorter: (a, b) => (a.exported_at > b.exported_at ? 1 : -1),
    },
  ];
  const payments_columns = [
    {
      title: "Payee",
      dataIndex: "payee",
      key: "payee",
      sorter: (a, b) => (a.payee.toUpperCase() < b.payee.toUpperCase() ? -1 : a.payee.toUpperCase() > b.payee.toUpperCase() ? 1 : 0),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (value) => props.FormatNumberToCurrency(value),
      sorter: (a, b) => (a.amount.toUpperCase() < b.amount.toUpperCase() ? -1 : a.amount.toUpperCase() > b.amount.toUpperCase() ? 1 : 0),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (text == "settled" ? <Tag color="#87d068">In Progress</Tag> : <Tag color="#108ee9">Settled</Tag>),
      sorter: (a, b) => (a.status.toUpperCase() < b.status.toUpperCase() ? -1 : a.status.toUpperCase() > b.status.toUpperCase() ? 1 : 0),
    },
    {
      title: "Date Received",
      dataIndex: "received_at",
      key: "received_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.received_at.toUpperCase() < b.received_at.toUpperCase() ? -1 : a.received_at.toUpperCase() > b.received_at.toUpperCase() ? 1 : 0),
      defaultSortOrder: "asc",
    },
    {
      title: "Memo",
      dataIndex: "memo",
      key: "memo",
      render: (text) => <Input.TextArea value={text} />,
      sorter: (a, b) => (a.memo.toUpperCase() < b.memo.toUpperCase() ? -1 : a.memo.toUpperCase() > b.memo.toUpperCase() ? 1 : 0),
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (value) => <Input readOnly value={value} />,
      sorter: (a, b) => (a.transaction_id.toUpperCase() > b.transaction_id.toUpperCase() ? 1 : -1),
    },
  ];
  const invoice_columns = [
    {
      title: "Invoice Number",
      dataIndex: "name",
      key: "name",
      render: (value, object) => (
        <Link to={"/invoicing/" + object.tag}>
          <Tag>#{value}</Tag>
        </Link>
      ),
      sorter: (a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Invoice Total",
      dataIndex: "total",
      key: "total",
      align: "right",
      render: (text, row) => props.FormatNumberToCurrency(text),
      sorter: (a, b) => (a.total < b.total ? -1 : 1),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (text == 1 ? <Tag color="#108ee9">Proposed</Tag> : <Tag color="#87d068">Finalized</Tag>),
      sorter: (a, b) => (a.status.toUpperCase() < b.status.toUpperCase() ? -1 : a.status.toUpperCase() > b.status.toUpperCase() ? 1 : 0),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.created_at.toUpperCase() < b.created_at.toUpperCase() ? -1 : a.created_at.toUpperCase() > b.created_at.toUpperCase() ? 1 : 0),
      defaultSortOrder: "descend",
    },
    {
      title: "Last Exported At",
      dataIndex: "exported_at",
      key: "exported_at",
      align: "right",
      render: (value, row) => (value ? props.MakeDateTimeReadable(value) : "Not Yet Exported"),
      sorter: (a, b) => (a.exported_at > b.exported_at ? 1 : -1),
    },
  ];

  const tabs = [
    {
      key: "1",
      label: (
        <Badge count={selectedClients.length}>
          <>Client Exports</>
        </Badge>
      ),
      children: (
        <>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <label className="col-form-label-sm">Date Range *</label>
              <DatePicker.RangePicker
                value={clientDateRange}
                className="w-100"
                onChange={(e) => {
                  setClientDateRange(e);
                }}
                format="MM/DD/YYYY"
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Client Filter *</label>
              <Select
                value={clientFilter}
                className="w-100"
                options={[
                  { label: "Unexported Clients", value: false },
                  { label: "All Clients", value: true },
                ]}
                onChange={(e) => {
                  setClientFilter(e);
                }}
              />
            </Col>
            <Col span={12}></Col>
            <Col span={24}>
              <Table columns={clients_columns} dataSource={clients} rowSelection={clientsRowSelection} pagination={false} />
            </Col>
          </Row>
        </>
      ),
    },

    {
      key: "3",
      label: (
        <Badge count={selectedInvoices.length}>
          <>Invoice Exports</>
        </Badge>
      ),
      children: (
        <>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <label className="col-form-label-sm">Date Range *</label>
              <DatePicker.RangePicker value={invoiceDateRange} className="w-100" onChange={(e) => setInvoiceDateRange(e)} format="MM/DD/YYYY" />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Invoice Filter *</label>
              <Select
                value={invoiceFilter}
                className="w-100"
                options={[
                  { label: "Unexported Invoices", value: false },
                  { label: "All Invoices", value: true },
                ]}
                onChange={(e) => {
                  setInvoiceFilter(e);
                }}
              />
            </Col>
            <Col span={12}></Col>
            <Col span={24}>
              <Table columns={invoice_columns} dataSource={invoices} rowSelection={invoicesRowSelection} pagination={false} />
            </Col>
          </Row>
        </>
      ),
    },
    {
      key: "2",
      label: (
        <Badge count={selectedPayments.length}>
          <>Payment Exports</>
        </Badge>
      ),
      children: (
        <>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <label className="col-form-label-sm">Date Range *</label>
              <DatePicker.RangePicker value={itemDateRange} className="w-100" onChange={(e) => setItemDateRange(e)} format="MM/DD/YYYY" />
            </Col>
            <Col span={6}></Col>
            <Col span={12}></Col>
            <Col span={24}>
              <Table columns={payments_columns} dataSource={payments} rowSelection={paymentsRowSelection} pagination={false} />
            </Col>
          </Row>
        </>
      ),
    },
  ];

  useEffect(() => {
    GetClients();
    GetPayments();
    GetInvoices();
  }, []);
  useEffect(() => {
    GetClients();
  }, [clientDateRange, clientFilter]);
  useEffect(() => {
    GetPayments();
  }, [itemDateRange]);
  useEffect(() => {
    GetInvoices();
  }, [invoiceDateRange, invoiceFilter]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">QuickBooks Desktop Exports</h1>
        </div>
        <Card
          title={<>Exports</>}
          extra={
            <>
              <Tooltip title="This will export all selected clients, items, and invoices into one file.">
                <Button type="primary" onClick={() => GetExportFile()}>
                  <FontAwesomeIcon icon={faFileExport} className="mr-2" />
                  Download Export File
                </Button>
              </Tooltip>
            </>
          }
        >
          <Tabs items={tabs} defaultActiveKey="1" />
        </Card>
        {/* //----------------------------|Previous Exports Modal|----------------------------\\ */}
        <div className="modal fade" id="previous-exports-modal" tabIndex={-1} role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Previous Exports</h5>
                <button type="button" id="job-delete-modal-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body m-3">
                <table id="previous-exports-datatable" className="table table-striped" style={{ width: "100%" }}></table>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-info" data-bs-dismiss="modal" aria-label="Close">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* //----------------------------|Explain Why We Can't Export Modal|----------------------------\\ */}
        <div className="modal fade" id="defaultModalDangerExplain" tabIndex={-1} role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Unable to export this batch</h5>
                <button type="button" id="user-delete-modal-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body m-3">
                <p className="mb-0 text-center">
                  <b>Exporting invoices requires that the invoice items all have the relevant QuickBooks information.</b>
                  <br></br>
                  <br></br>Please review the items below for the QuickBooks fields, and then try again.
                  <hr></hr>
                  {/* @ZACH!!! */}
                  {/* {this.state.qb_items_errors.map((e) => {
                    return (
                      <div>
                        <b>{e.name}</b>
                      </div>
                    );
                  })} */}
                </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-info" data-bs-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export class ExportInvoicesOld extends Component {
  constructor(props) {
    super(props);
    this.DeleteModalCloseButton = createRef();
    // eslint-disable-next-line no-unused-vars
    this.state = {
      invoices_ready_to_export: [],
      invoices_previously_exported: [],
      invoices: [],
      exports: [],
      clients_ready_to_export: [],
      clients_exports: [],
      start_date_range: moment().tz("America/Chicago").subtract(90, "d").format("MM/DD/YYYY"),
      end_date_range: moment().tz("America/Chicago").format("MM/DD/YYYY"),
      status_id: -1,
      qb_items_errors: [],
      payments_exports: [],
      payments_ready_to_export: [],
      start_date: moment().subtract(3, "months").tz("America/Chicago").format("MM/DD/YYYY"),
      end_date: moment().tz("America/Chicago").format("MM/DD/YYYY"),
      previous_exports: [],
    };

    window.AddInvoiceToExports = this.AddInvoiceToExports;
    window.RemoveInvoiceFromExports = this.RemoveInvoiceFromExports;
    window.AddClientToExports = this.AddClientToExports;
    window.RemoveClientFromExports = this.RemoveClientFromExports;
    window.AddPaymentToExports = this.AddPaymentToExports;
    window.RemovePaymentFromExports = this.RemovePaymentFromExports;
    window.AddExportBatch = this.AddExportBatch;
  }
  componentDidMount() {
    $("#invoices-datatable").DataTable({
      data: this.state.invoices_ready_to_export,
      dom: "lfrtip",
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, "All"],
      ],
      columns: [
        {
          data: "name",
          name: "Number",
          title: "Number",
          render: (data, type, row) => {
            return renderToString(
              <div className="btn btn-light" id={row.id}>
                #{row.name}
              </div>,
            );
          },
        },
        { data: "client_name", title: "Client", orderable: true },
        {
          data: "status",
          title: "Status",
          orderable: true,
          render: (data, type, row) => {
            if (data === 1) return renderToString(<span className="badge rounded-pill bg-primary">Proposed</span>);
            if (data === 2) return renderToString(<span className="badge rounded-pill bg-success">Finalized</span>);
          },
        },
        {
          data: "export_batches_xref",
          title: "Export Batch",
          defaultContent: "",
          orderable: true,
          render: (data, type, row) => {
            if (data) return `<button class="btn btn-light" ebid=` + data + ` onClick="AddExportBatch(event)">#` + data + ` </button>`;
          },
        },
        {
          data: "invoiced_at",
          title: "Date Invoiced",
          orderable: false,
          render: (data, type, row) => {
            return this.props.MakeDateTimeReadable(data);
          },
        },
        {
          data: "id",
          title: "Actions",
          render: (data, type, row) => {
            //return data;
            return `<button class="btn btn-info" onClick="AddInvoiceToExports(event)" iid=` + row.id + `>` + renderToString(<FontAwesomeIcon icon="angle-double-right" />) + `</button>`;
          },
          orderable: false,
        },
      ],
    });
    $("#exports-datatable").DataTable({
      data: this.state.invoices_ready_to_export,
      dom: "lfrtip",
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, "All"],
      ],
      columns: [
        {
          data: "name",
          name: "Number",
          title: "Number",
          render: (data, type, row) => {
            return renderToString(
              <div className="btn btn-light" id={row.id}>
                #{row.name}
              </div>,
            );
          },
        },
        { data: "client_name", title: "Client", orderable: true },
        {
          data: "status",
          title: "Status",
          orderable: true,
          render: (data, type, row) => {
            if (data === 1) return renderToString(<span className="badge rounded-pill bg-primary">Proposed</span>);
            if (data === 2) return renderToString(<span className="badge rounded-pill bg-success">Finalized</span>);
          },
        },
        {
          data: "export_batches_xref",
          title: "Export Batch",
          defaultContent: "",
          orderable: true,
          render: (data, type, row) => {
            if (data) return `<button class="btn btn-light" ebid=` + data + ` onClick="AddExportBatch(event)">#` + data + ` </button>`;
          },
        },
        {
          data: "invoiced_at",
          title: "Date Invoiced",
          orderable: false,
          render: (data, type, row) => {
            return this.props.MakeDateTimeReadable(data);
          },
        },
        {
          data: "id",
          title: "Actions",
          render: (data, type, row) => {
            //return data;
            return `<button class="btn btn-danger" onClick="RemoveInvoiceFromExports(event)" iid=` + row.id + `>` + renderToString(<FontAwesomeIcon icon="angle-double-left" />) + `</button>`;
          },
          orderable: false,
        },
      ],
    });
    $("#clients-ready-datatable").DataTable({
      data: this.state.invoices_ready_to_export,
      dom: "lfrtip",
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, "All"],
      ],
      columns: [
        { data: "name", title: "Name" },
        { data: "created_at", title: "Date Created", render: (data, type, row) => this.props.MakeDateTimeReadable(data) },
        {
          data: "export_batches_xref",
          title: "Export Batch",
          defaultContent: "",
          orderable: true,
          render: (data, type, row) => {
            if (data) return `<button class="btn btn-light" ebid=` + data + ` onClick="AddExportBatch(event)">#` + data + ` </button>`;
          },
        },
        {
          data: "id",
          title: "Actions",
          render: (data, type, row) => {
            //return data;
            return `<button class="btn btn-info" onClick="AddClientToExports(event)" iid=` + row.id + `>` + renderToString(<FontAwesomeIcon icon="angle-double-right" />) + `</button>`;
          },
          orderable: false,
        },
      ],
    });
    $("#clients-exports-datatable").DataTable({
      data: this.state.invoices_ready_to_export,
      dom: "lfrtip",
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, "All"],
      ],
      columns: [
        { data: "name", title: "Name" },
        { data: "created_at", title: "Date Created", render: (data, type, row) => this.props.MakeDateTimeReadable(data) },
        {
          data: "export_batches_xref",
          title: "Export Batch",
          defaultContent: "",
          orderable: true,
          render: (data, type, row) => {
            if (data) return `<button class="btn btn-light" ebid=` + data + ` onClick="AddExportBatch(event)">#` + data + ` </button>`;
          },
        },
        {
          data: "id",
          title: "Actions",
          render: (data, type, row) => {
            //return data;
            return `<button class="btn btn-danger" onClick="RemoveClientFromExports(event)" iid=` + row.id + `>` + renderToString(<FontAwesomeIcon icon="angle-double-left" />) + `</button>`;
          },
          orderable: false,
        },
      ],
    });
    $("#payments-ready-datatable").DataTable({
      data: this.state.invoices_ready_to_export,
      dom: "lfrtip",
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, "All"],
      ],
      columns: [
        {
          data: "transaction_id",
          title: "Transaction ID",
          render: (data, type, row) => {
            return "<div class='form-control'><div class='text-muted text-sm'>" + data + "</div></div>";
          },
        },
        { data: "client_name", title: "Client" },
        { data: "memo", title: "Memo" },
        { data: "recieved_at", title: "Date Recieved", render: (data, type, row) => this.props.MakeDateTimeReadable(data) },
        {
          data: "export_batches_xref",
          title: "Export Batch",
          defaultContent: "",
          orderable: true,
          render: (data, type, row) => {
            if (data) return `<button class="btn btn-light" ebid=` + data + ` onClick="AddExportBatch(event)">#` + data + ` </button>`;
          },
        },
        {
          data: "id",
          title: "Actions",
          render: (data, type, row) => {
            //return data;
            return `<button class="btn btn-info" onClick="AddPaymentToExports(event)" iid=` + row.id + `>` + renderToString(<FontAwesomeIcon icon="angle-double-right" />) + `</button>`;
          },
          orderable: false,
        },
      ],
    });
    $("#payments-exports-datatable").DataTable({
      data: this.state.invoices_ready_to_export,
      dom: "lfrtip",
      lengthMenu: [
        [5, 10, 25, 50, -1],
        [5, 10, 25, 50, "All"],
      ],
      columns: [
        {
          data: "transaction_id",
          title: "Transaction ID",
          render: (data, type, row) => {
            return "<div class='form-control'><div class='text-muted text-sm'>" + data + "</div></div>";
          },
        },
        { data: "client_name", title: "Client" },
        { data: "memo", title: "Memo" },
        { data: "recieved_at", title: "Date Recieved", render: (data, type, row) => this.props.MakeDateTimeReadable(data) },
        {
          data: "export_batches_xref",
          title: "Export Batch",
          defaultContent: "",
          orderable: true,
          render: (data, type, row) => {
            if (data) return `<button class="btn btn-light" ebid=` + data + ` onClick="AddExportBatch(event)">#` + data + ` </button>`;
          },
        },
        {
          data: "id",
          title: "Actions",
          render: (data, type, row) => {
            //return data;
            return `<button class="btn btn-danger" onClick="RemovePaymentFromExports(event)" iid=` + row.id + `>` + renderToString(<FontAwesomeIcon icon="angle-double-left" />) + `</button>`;
          },
          orderable: false,
        },
      ],
    });

    $("#daterange-selector").daterangepicker({
      opens: "left",
      autoApply: true,
      startDate: moment().subtract(3, "months").format("MM/DD/YYYY"),
      endDate: moment().format("MM/DD/YYYY"),
      ranges: {
        Today: [moment(), moment()],
        "This Week": [moment().startOf("week"), moment()],
        "Last Week": [moment().subtract(1, "week").startOf("week"), moment().subtract(1, "week").endOf("week")],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [moment().subtract("1", "month").startOf("month"), moment().subtract("1", "month").endOf("month")],
        "This Year": [moment().startOf("year"), moment()],
      },
    });
    this.SearchItems();
  }
  //--------------Gets--------------\\
  GetUnexportedInvoices = () => {
    let dataObj = {
      "x-access-token": this.props.authToken,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      status_id: 2,
    };
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/get/unexported", dataObj)
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState(
            {
              invoices_ready_to_export: response.data.data,
            },
            () => {
              $("#invoices-datatable").DataTable().clear().rows.add(this.state.invoices_ready_to_export).draw();
              $("#exports-datatable").DataTable().clear().rows.add(this.state.exports).draw();
            },
          );
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetUnexportedClients = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/clients/get/unexported", {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ clients_ready_to_export: response["data"]["data"] }, () => {
            $("#clients-ready-datatable").DataTable().clear().rows.add(this.state.clients_ready_to_export).draw();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetUnexportedPayments = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/payments/get/unexported", {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ payments_ready_to_export: response["data"]["data"] }, () => {
            $("#payments-ready-datatable").DataTable().clear().rows.add(this.state.payments_ready_to_export).draw();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetInvoices = () => {
    let dataObj = {
      "x-access-token": this.props.authToken,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      status_id: 2,
    };
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/get/all/for-exports", dataObj)
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ invoices_ready_to_export: response.data.data }, () => {
            $("#invoices-datatable").DataTable().clear().rows.add(this.state.invoices_ready_to_export).draw();
            $("#exports-datatable").DataTable().clear().rows.add(this.state.exports).draw();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        // this.props.MakeNotification("success", "Successfully loaded all invoices created during that date range.");
      });
  };
  GetClients = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/clients/get/all/for-exports", {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ clients_ready_to_export: response["data"]["data"] }, () => {
            $("#clients-ready-datatable").DataTable().clear().rows.add(this.state.clients_ready_to_export).draw();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        // this.props.MakeNotification("success", "Successfully loaded all clients created during that date range.");
      });
  };
  GetPayments = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/payments/get/all/for-exports", {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ payments_ready_to_export: response["data"]["data"] }, () => {
            $("#payments-ready-datatable").DataTable().clear().rows.add(this.state.payments_ready_to_export).draw();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        // this.props.MakeNotification("success", "Successfully loaded all payments received during that date range.");
      });
  };
  GetPreviousExports = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/exports/get/all", {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState({ previous_exports: response["data"]["data"] }, () => {
            $("#previous-exports-datatable").DataTable().clear().rows.add(this.state.previous_exports).draw();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        // this.props.MakeNotification("success", "Successfully loaded all payments received during that date range.");
      });
  };
  //--------------End Gets--------------\\
  //--------------Actions--------------\\
  AddInvoiceToExports = (e) => {
    let index = Number($(e.target).closest("button").attr("iid"));
    this.setState(
      (prevState) => ({
        invoices_ready_to_export: this.state.invoices_ready_to_export.filter((l) => l.id !== index),
        exports: [...prevState.exports, this.state.invoices_ready_to_export.find((l) => l.id === index)],
      }),
      (e) => {
        $("#invoices-datatable").DataTable().clear().rows.add(this.state.invoices_ready_to_export).draw();
        $("#exports-datatable").DataTable().clear().rows.add(this.state.exports).draw();
      },
    );
  };
  AddExportBatch = (e) => {
    let eb = Number($(e.target).closest("button").attr("ebid"));
    console.log(eb);
    this.setState(
      (prevState) => ({
        exports: [...prevState.exports, ...this.state.invoices_ready_to_export.filter((l) => l.export_batches_xref === eb)],
        invoices_ready_to_export: this.state.invoices_ready_to_export.filter((l) => l.export_batches_xref !== eb),

        clients_exports: [...prevState.clients_exports, ...this.state.clients_ready_to_export.filter((l) => l.export_batches_xref === eb)],
        clients_ready_to_export: this.state.clients_ready_to_export.filter((l) => l.export_batches_xref !== eb),

        payments_exports: [...prevState.payments_exports, ...this.state.payments_ready_to_export.filter((l) => l.export_batches_xref === eb)],
        payments_ready_to_export: this.state.payments_ready_to_export.filter((l) => l.export_batches_xref !== eb),
      }),
      (e) => {
        $("#invoices-datatable").DataTable().clear().rows.add(this.state.invoices_ready_to_export).draw();
        $("#exports-datatable").DataTable().clear().rows.add(this.state.exports).draw();

        $("#clients-ready-datatable").DataTable().clear().rows.add(this.state.clients_ready_to_export).draw();
        $("#clients-exports-datatable").DataTable().clear().rows.add(this.state.clients_exports).draw();

        $("#payments-ready-datatable").DataTable().clear().rows.add(this.state.payments_ready_to_export).draw();
        $("#payments-exports-datatable").DataTable().clear().rows.add(this.state.payments_exports).draw();
      },
    );
  };
  RemoveInvoiceFromExports = (e) => {
    let index = Number($(e.target).closest("button").attr("iid"));

    this.setState(
      (prevState) => ({ invoices_ready_to_export: [...prevState.invoices_ready_to_export, this.state.exports.find((l) => l.id === index)], exports: this.state.exports.filter((l) => l.id !== index) }),
      (e) => {
        $("#invoices-datatable").DataTable().clear().rows.add(this.state.invoices_ready_to_export).draw();
        $("#exports-datatable").DataTable().clear().rows.add(this.state.exports).draw();
      },
    );
  };
  AddAllToExports = (e) => {
    this.setState(
      (prevState) => ({ invoices_ready_to_export: [], exports: [...prevState.exports, ...this.state.invoices_ready_to_export] }),
      (e) => {
        $("#invoices-datatable").DataTable().clear().rows.add(this.state.invoices_ready_to_export).draw();
        $("#exports-datatable").DataTable().clear().rows.add(this.state.exports).draw();
      },
    );
  };
  RemoveAllFromExports = (e) => {
    this.setState(
      (prevState) => ({ invoices_ready_to_export: [...prevState.invoices_ready_to_export, ...this.state.exports], exports: [] }),
      (e) => {
        $("#invoices-datatable").DataTable().clear().rows.add(this.state.invoices_ready_to_export).draw();
        $("#exports-datatable").DataTable().clear().rows.add(this.state.exports).draw();
      },
    );
  };
  AddClientToExports = (e) => {
    let index = Number($(e.target).closest("button").attr("iid"));
    this.setState(
      (prevState) => ({
        clients_ready_to_export: this.state.clients_ready_to_export.filter((l) => l.id !== index),
        clients_exports: [...prevState.clients_exports, this.state.clients_ready_to_export.find((l) => l.id === index)],
      }),
      (e) => {
        $("#clients-ready-datatable").DataTable().clear().rows.add(this.state.clients_ready_to_export).draw();
        $("#clients-exports-datatable").DataTable().clear().rows.add(this.state.clients_exports).draw();
      },
    );
  };
  RemoveClientFromExports = (e) => {
    let index = Number($(e.target).closest("button").attr("iid"));
    this.setState(
      (prevState) => ({
        clients_ready_to_export: [...prevState.clients_ready_to_export, this.state.clients_exports.find((l) => l.id === index)],
        clients_exports: this.state.clients_exports.filter((l) => l.id !== index),
      }),
      (e) => {
        $("#clients-ready-datatable").DataTable().clear().rows.add(this.state.clients_ready_to_export).draw();
        $("#clients-exports-datatable").DataTable().clear().rows.add(this.state.clients_exports).draw();
      },
    );
  };
  AddAllClientsToExports = (e) => {
    this.setState(
      (prevState) => ({ clients_ready_to_export: [], clients_exports: [...prevState.clients_exports, ...this.state.clients_ready_to_export] }),
      (e) => {
        $("#clients-ready-datatable").DataTable().clear().rows.add(this.state.clients_ready_to_export).draw();
        $("#clients-exports-datatable").DataTable().clear().rows.add(this.state.clients_exports).draw();
      },
    );
  };
  RemoveAllClientsFromExports = (e) => {
    this.setState(
      (prevState) => ({ clients_ready_to_export: [...prevState.clients_ready_to_export, ...this.state.clients_exports], clients_exports: [] }),
      (e) => {
        $("#clients-ready-datatable").DataTable().clear().rows.add(this.state.clients_ready_to_export).draw();
        $("#clients-exports-datatable").DataTable().clear().rows.add(this.state.clients_exports).draw();
      },
    );
  };
  AddPaymentToExports = (e) => {
    let index = Number($(e.target).closest("button").attr("iid"));
    this.setState(
      (prevState) => ({
        payments_ready_to_export: this.state.payments_ready_to_export.filter((l) => l.id !== index),
        payments_exports: [...prevState.payments_exports, this.state.payments_ready_to_export.find((l) => l.id === index)],
      }),
      (e) => {
        $("#payments-ready-datatable").DataTable().clear().rows.add(this.state.payments_ready_to_export).draw();
        $("#payments-exports-datatable").DataTable().clear().rows.add(this.state.payments_exports).draw();
      },
    );
  };
  RemovePaymentFromExports = (e) => {
    let index = Number($(e.target).closest("button").attr("iid"));
    this.setState(
      (prevState) => ({
        payments_ready_to_export: [...this.state.payments_ready_to_export, this.state.payments_exports.find((l) => l.id === index)],
        payments_exports: [...prevState.payments_exports.filter((l) => l.id !== index)],
      }),
      (e) => {
        $("#payments-ready-datatable").DataTable().clear().rows.add(this.state.payments_ready_to_export).draw();
        $("#payments-exports-datatable").DataTable().clear().rows.add(this.state.payments_exports).draw();
      },
    );
  };
  AddAllPaymentsToExports = (e) => {
    this.setState(
      (prevState) => ({ payments_ready_to_export: [], payments_exports: [...prevState.payments_exports, ...this.state.payments_ready_to_export] }),
      (e) => {
        $("#payments-ready-datatable").DataTable().clear().rows.add(this.state.payments_ready_to_export).draw();
        $("#payments-exports-datatable").DataTable().clear().rows.add(this.state.payments_exports).draw();
      },
    );
  };
  RemoveAllPaymentsFromExports = (e) => {
    this.setState(
      (prevState) => ({ payments_ready_to_export: [...prevState.payments_ready_to_export, ...this.state.payments_exports], payments_exports: [] }),
      (e) => {
        $("#payments-ready-datatable").DataTable().clear().rows.add(this.state.payments_ready_to_export).draw();
        $("#payments-exports-datatable").DataTable().clear().rows.add(this.state.payments_exports).draw();
      },
    );
  };

  GetExportFile = () => {
    if (this.state.exports.length === 0 && this.state.clients_exports.length === 0 && this.state.payments_exports.length === 0) {
      this.props.MakeNotification("warning", "Please choose some items to export.");
      return;
    }
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/exports/all", {
      "x-access-token": this.props.authToken,
      invoices: this.state.exports,
      clients: this.state.clients_exports,
      payments: this.state.payments_exports,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
          if (response["data"]["qberror"]) {
            this.setState({ qb_items_errors: response["data"]["data"] }, (e) => {
              window.$("#defaultModalDangerExplain").modal("show");
            });
          }
        }
        if (response["data"]["status"] === "success") {
          //HERE
          let iifContent = "data:text/iif;charset=utf-8,";
          console.log(response.data.data); //, / ? : @ & = + $ * #
          iifContent += response["data"]["data"].replace(/[?@=+$*#]/g, " ");
          let encodedURI = window.encodeURI(iifContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedURI);
          let now = moment().format("MMDDYY");
          link.setAttribute("download", "InvoiceExport-EB" + response["data"]["batch_id"] + "-" + now + ".iif");
          document.body.appendChild(link); // Required for FF
          this.props.MakeNotification("success", "Export file successfully created.");
          link.click(); // This will download the data file
          $("#exports-datatable").DataTable().destroy();
          this.setState({ exports: [] }, (e) => {
            $("#exports-datatable").DataTable();
          });
          //window.open(encodedURI);
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {
        this.GetUnexportedInvoices();
        this.GetUnexportedClients();
        this.GetUnexportedPayments();
      });
  };
  SearchItems = (exported = false) => {
    this.setState(
      {
        start_date: moment($("#daterange-selector").val().substr(0, $("#daterange-selector").val().indexOf(" -")))
          .startOf("day")
          .tz("America/Chicago")
          .format("YYYY-MM-DD HH:mm:ss"),
        end_date: moment(
          $("#daterange-selector")
            .val()
            .substr($("#daterange-selector").val().indexOf(" - ") + 3),
        )
          .endOf("day")
          .tz("America/Chicago")
          .format("YYYY-MM-DD HH:mm:ss"),
      },
      () => {
        if (exported) {
          this.GetClients();
          this.GetInvoices();
          this.GetPayments();
        } else {
          this.GetUnexportedInvoices();
          this.GetUnexportedClients();
          this.GetUnexportedPayments();
        }
      },
    );
  };

  render() {
    return (
      <main className="content">
        <div className="container-fluid">
          <div className="header">
            <h1 className="header-title">Exports</h1>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div>
                    <h2 className="d-sm-inline">QuickBooks Desktop Exports</h2>
                    <FontAwesomeIcon icon="info-circle" className="mx-4" data-tip="Move items to the right column that you want to export, then press the export button." /> {/*<ReactTooltip /> */}
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-2">
                      <div className="row">
                        <div className="col-md-4">
                          <label className="col-form-label-sm">Items Created During</label>
                          <input className="form-control" type="text" id="daterange-selector" />
                        </div>
                        <div className="col-md-2">
                          <button
                            className="btn btn-primary form-control"
                            style={{ marginTop: "24.8px", height: "38px" }}
                            onClick={() => {
                              this.SearchItems(false);
                            }}
                            data-tip="Fetch all unexported items during the date range specified."
                          >
                            <FontAwesomeIcon icon="circle" className="pe-none" />
                            &nbsp;Unexported
                          </button>
                        </div>
                        <div className="col-md-2">
                          <button
                            className="btn btn-primary form-control"
                            style={{ marginTop: "24.8px" }}
                            onClick={() => {
                              this.SearchItems(true);
                            }}
                            data-tip="Fetch all items (including previously exported) during the date range specified."
                          >
                            <FontAwesomeIcon icon="check-circle" className="pe-none" />
                            &nbsp;All
                          </button>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-2">
                          <button
                            className="btn btn-success form-control"
                            onClick={this.GetExportFile}
                            style={{ marginTop: "24.8px" }}
                            data-tip="Create a QuickBooks Desktop import file for all the items in the right columns."
                          >
                            <FontAwesomeIcon icon="file-export" />
                            &nbsp;Export!
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 text-right mb-2">
                      <div className="row">
                        <div className="col-md-4">
                          {/* <button
                              className="btn btn-primary form-control"
                              onClick={() => {
                                this.SearchItems(true);
                              }}
                            >
                              <FontAwesomeIcon icon="folder-open" className="pe-none" />
                              &nbsp;View Previous Exports
                            </button> */}
                        </div>
                        <div className="col-md-4"></div>
                        <div className="col-md-4"></div>
                      </div>
                    </div>
                  </div>
                  <div className="card-actions float-end">
                    {/* <a href="#" className="me-1">
                      <FontAwesomeIcon icon="sync" id="clients-list-refresh" onClick={this.GetItems} />
                    </a>
                    <a href="#" className="me-1">
                      <FontAwesomeIcon icon="plus" id="clients-list-refresh" onClick={this.PrepAddItem} />
                    </a> */}
                  </div>
                </div>
                <hr />
                <div className="card-body">
                  {/* Client Exporting */}
                  <div className="row mb-5">
                    <div className="col-md-6">
                      <h5 className="card-title mb-0">Clients Ready to Export</h5>
                    </div>
                    <div className="col-md-6">
                      <h5 className="card-title mb-0">Client Export List</h5>
                    </div>
                    <div className="col-lg-6 ">
                      <table id="clients-ready-datatable" className="table table-striped" style={{ width: "100%" }}></table>
                      {/* button area */}
                      <div className=" mt-1">
                        <button className="btn btn-success" onClick={this.AddAllClientsToExports}>
                          <FontAwesomeIcon icon="plus" />
                          &nbsp;Add All Clients
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <table id="clients-exports-datatable" className="table table-striped" style={{ width: "100%" }}></table>
                      <div className="mt-1">
                        <div className="row">
                          <div className=" col-md-6">
                            <button className="btn btn-danger" onClick={this.RemoveAllClientsFromExports}>
                              <FontAwesomeIcon icon="minus" />
                              &nbsp;Remove All Clients
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Client Exporting End */}
                  <hr />
                  {/* Invoice Exporting */}
                  <div className="row mb-5">
                    <div className="col-md-6">
                      <h5 className="card-title mb-0">Invoices Ready to Export</h5>
                    </div>
                    <div className="col-md-6">
                      <h5 className="card-title mb-0">Invoice Export List</h5>
                    </div>
                    <div className="col-lg-6 ">
                      <table id="invoices-datatable" className="table table-striped" style={{ width: "100%" }}></table>
                      {/* button area */}
                      <div className=" mt-1">
                        <button className="btn btn-success" onClick={this.AddAllToExports}>
                          <FontAwesomeIcon icon="plus" />
                          &nbsp;Add All Invoices
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-6 ">
                      <table id="exports-datatable" className="table table-striped" style={{ width: "100%" }}></table>
                      <div className="mt-1">
                        <div className="row">
                          <div className=" col-md-6">
                            <button className="btn btn-danger" onClick={this.RemoveAllFromExports}>
                              <FontAwesomeIcon icon="minus" />
                              &nbsp;Remove All Exports
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Invoice Exporting End */}
                  <hr />
                  {/* Payments Exporting */}
                  <div className="row mb-5">
                    <div className="col-md-6">
                      <h5 className="card-title mb-0">Payments Ready to Export</h5>
                    </div>
                    <div className="col-md-6">
                      <h5 className="card-title mb-0">Payment Export List</h5>
                    </div>
                    <div className="col-lg-6 ">
                      <table id="payments-ready-datatable" className="table table-striped" style={{ width: "100%" }}></table>
                      {/* button area */}
                      <div className=" mt-1">
                        <button className="btn btn-success" onClick={this.AddAllPaymentsToExports}>
                          <FontAwesomeIcon icon="plus" />
                          &nbsp;Add All Payments
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-6 ">
                      <table id="payments-exports-datatable" className="table table-striped" style={{ width: "100%" }}></table>
                      <div className="mt-1">
                        <div className="row">
                          <div className=" col-md-6">
                            <button className="btn btn-danger" onClick={this.RemoveAllPaymentsFromExports}>
                              <FontAwesomeIcon icon="minus" />
                              &nbsp;Remove All Payments
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Payments Exporting End */}
                </div>
              </div>
            </div>
          </div>
          {/* //----------------------------|Previous Exports Modal|----------------------------\\ */}
          <div className="modal fade" id="previous-exports-modal" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Previous Exports</h5>
                  <button type="button" id="job-delete-modal-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                </div>
                <div className="modal-body m-3">
                  <table id="previous-exports-datatable" className="table table-striped" style={{ width: "100%" }}></table>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-info" data-bs-dismiss="modal" aria-label="Close">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* //----------------------------|Explain Why We Can't Export Modal|----------------------------\\ */}
          <div className="modal fade" id="defaultModalDangerExplain" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Unable to export this batch</h5>
                  <button type="button" id="user-delete-modal-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                </div>
                <div className="modal-body m-3">
                  <p className="mb-0 text-center">
                    <b>Exporting invoices requires that the invoice items all have the relevant QuickBooks information.</b>
                    <br></br>
                    <br></br>Please review the items below for the QuickBooks fields, and then try again.
                    <hr></hr>
                    {this.state.qb_items_errors.map((e) => {
                      return (
                        <div>
                          <b>{e.name}</b>
                        </div>
                      );
                    })}
                  </p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-info" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default ExportInvoices;
